'use client';

import a__default, { forwardRef } from "react";
import b from "../lib/IconBase.js";
import t$1 from "../defs/MapPinLine.js";
var n = Object.defineProperty, p = Object.defineProperties;
var f = Object.getOwnPropertyDescriptors;
var a = Object.getOwnPropertySymbols;
var s = Object.prototype.hasOwnProperty, c = Object.prototype.propertyIsEnumerable;
var i = (o, e, r) => e in o ? n(o, e, { enumerable: true, configurable: true, writable: true, value: r }) : o[e] = r, t = (o, e) => {
  for (var r in e || (e = {}))
    s.call(e, r) && i(o, r, e[r]);
  if (a)
    for (var r of a(e))
      c.call(e, r) && i(o, r, e[r]);
  return o;
}, m = (o, e) => p(o, f(e));
const L = forwardRef((o, e) => /* @__PURE__ */ a__default.createElement(b, m(t({ ref: e }, o), { weights: t$1 })));
L.displayName = "MapPinLine";
export {
  L as MapPinLine
};
